import type {
  EvalInput,
  EvalOutput,
  MagicDefinition,
  MagicDefinitionCreateInput,
  MagicDefinitionUpdateInput,
  MagicEvalOutput,
  MagicEvent,
} from "../types/magic.ts";
import { useApiMutation } from "./use-api-mutation.ts";
import { useApiQuery } from "./use-api-query.ts";

export const useMagicDefinitions = () => {
  return useApiQuery<MagicDefinition[]>("/x/definitions");
};

export const useCreateMagicDefinition = () => {
  return useApiMutation<MagicDefinitionCreateInput, MagicDefinition>("POST", "/x/definitions");
};

export const useUpdateMagicDefinition = (definitionId: string) => {
  return useApiMutation<MagicDefinitionUpdateInput, MagicDefinition>(
    "PUT",
    `/x/definitions/${definitionId}`,
  );
};

export const useDeleteMagicDefinition = (definitionId: string) => {
  return useApiMutation<void, { message: string }>("DELETE", `/x/definitions/${definitionId}`);
};

export const useMagicEvents = (name?: string, xId?: string, limit?: number, offset?: number) => {
  const params = new URLSearchParams();
  if (name) params.append("name", name);
  if (xId) params.append("x_id", xId);
  if (limit !== undefined) params.append("limit", limit.toString());
  if (offset !== undefined) params.append("offset", offset.toString());

  const query = `/x/events${params.toString() ? `?${params.toString()}` : ""}`;

  return useApiQuery<MagicEvent[]>(query, {
    enabled: !!(name || xId),
  });
};

export const useEvaluateMagic = () => {
  return useApiMutation<EvalInput, EvalOutput>("POST", "/x/evaluate");
};

export const useMagicOutputs = (evId?: string, name?: string, limit?: number, offset?: number) => {
  const params = new URLSearchParams();
  if (evId) params.append("ev_id", evId);
  if (name) params.append("name", name);
  if (limit !== undefined) params.append("limit", limit.toString());
  if (offset !== undefined) params.append("offset", offset.toString());

  const query = `/x/outputs${params.toString() ? `?${params.toString()}` : ""}`;

  return useApiQuery<MagicEvalOutput[]>(query);
};
